import { render, staticRenderFns } from "./impactData.vue?vue&type=template&id=a55fc588&scoped=true&"
import script from "./impactData.vue?vue&type=script&lang=js&"
export * from "./impactData.vue?vue&type=script&lang=js&"
import style0 from "./impactData.vue?vue&type=style&index=0&id=a55fc588&scoped=true&lang=css&"
import style1 from "./impactData.vue?vue&type=style&index=1&id=a55fc588&scoped=true&lang=css&"
import style2 from "./impactData.vue?vue&type=style&index=2&id=a55fc588&scoped=true&lang=css&"
import style3 from "./impactData.vue?vue&type=style&index=3&id=a55fc588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55fc588",
  null
  
)

export default component.exports